import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-procedural-context',
	});

	const {
		attributes
	} = props;

	const {
		content
	} = attributes;

	return (
		<div {...blockProps}>
			<RichText.Content
				tagName='div'
				className='c4l-procedural-context-content'
				value={content}
			/>
		</div>
	);
}
